import { render, staticRenderFns } from "./EditAgents.vue?vue&type=template&id=64e9e737&"
import script from "./EditAgents.vue?vue&type=script&lang=js&"
export * from "./EditAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e9e737')) {
      api.createRecord('64e9e737', component.options)
    } else {
      api.reload('64e9e737', component.options)
    }
    module.hot.accept("./EditAgents.vue?vue&type=template&id=64e9e737&", function () {
      api.rerender('64e9e737', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/teams/Edit/EditAgents.vue"
export default component.exports